import {CustomerDTO} from "../customerDTO.interface";
import {CommsTemplateDTO} from "./commsTemplateDTO";

export interface CommsTemplateExcludeDTO {
  customerId?: number;
  customer?: CustomerDTO;
  commsTemplateId?: number;
  commsTemplate?: CommsTemplateDTO;
}
